import { render, staticRenderFns } from "./CreateClaim.vue?vue&type=template&id=5b2f882e&"
import script from "./CreateClaim.vue?vue&type=script&lang=js&"
export * from "./CreateClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports